import { SET_LANGUAGE, LangAction, LangState } from '../types/langTypes';

const localSorageLang = localStorage.getItem('app__language');

const initialState: LangState = {
  language: localSorageLang ? localSorageLang : 'ID',
};

const langReducer = (state = initialState, action: LangAction) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default langReducer;
